var _path, _rect, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _rect4, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 324,
    viewBox: "0 0 326 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel",
    d: "M-.5 324V162h162v162z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 324,
    width: 162,
    height: 162,
    rx: 81,
    transform: "rotate(-90 -.5 324)",
    fill: "#5ACBBC",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 324c-89.47 0-162-72.53-162-162 89.47 0 162 72.53 162 162zM161.5 162H-.5V0h162z",
    fill: "#fff",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 162,
    width: 162,
    height: 162,
    rx: 81,
    transform: "rotate(180 161.5 162)",
    fill: "#F2DA3A",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 0c0 89.47-72.53 162-162 162 0-89.47 72.53-162 162-162z",
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ACBBC",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel",
    d: "M323.5 0v162h-162V0z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    width: 162,
    height: 162,
    rx: 81,
    transform: "rotate(90 323.5 0)",
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 0c89.47 0 162 72.53 162 162-89.47 0-162-72.53-162-162z",
    fill: "#F2DA3A",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel",
    d: "M323.5 324h-162V162h162z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 324,
    width: 162,
    height: 162,
    rx: 81,
    transform: "rotate(180 323.5 324)",
    fill: "#B2CBDE",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 162c0 89.47-72.53 162-162 162 0-89.47 72.53-162 162-162z",
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgPatternDesktop as ReactComponent };